<template>
  <div class="autocomplete">
    <field
      class="field autofill"
      @input="debouncer(item[name])"
      :name="name"
      v-model="item[name]"
      :model="model"
      :label="label"
      @keydown.down="onArrowDown"
      @keydown.delete="shouldQuery = true"
      @keydown.up="onArrowUp"
      type="text"
      @keydown.enter="onEnter"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :autofocus="autofocus"
      :placeholder="placeholder"
    />
    <ul id="autocomplete-results" :class="classes" v-if="results.length > 0">
      <li
        v-for="(result, idx) in results"
        v-bind:key="idx"
        @click="setResult(result)"
        @populateFields="populateFields"
        class="autocomplete-result"
        :class="{ 'is-active': idx === arrowCounter }"
      >
        {{ result.name }} {{ result.city }} {{ result.country }}
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import CompanyApi from "@/api/Company.js";
import OrganizationApi from "@/api/Organization.js";
import Api from "@/api/Api.js";
import Field from "@/components/helpers/DataInput/Field";

const defaultClass = "autocomplete-results";

export default {
  name: "autocomplete",
  components: { Field },
  props: {
    item: Object,
    lead_id: "",
    newLabel: String,
    name: String,
    model: String,
    init: {
      // WTF does this do?
      type: String,
      default: "none"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    acMinCharacters: {
      type: Number,
      default: 4
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    label: String,
    isAsync: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      results: [],
      assocFields: [],
      companyFields: {},
      projectFields: {},
      items: [],
      arrowCounter: 0,
      initCompanyName: "",
      classes: [defaultClass, "hidden"],
      search: "",
      searched: "",
      fireCounter: 0,
      focused: false
    };
  },
  computed: {
    initialValue() {
      return this.item[this.name];
    }
  },
  mounted() {
    this.addListeners();
    Vue.prototype.$debouncedMethod = _.debounce(this.autoComplete, 400, {
      leading: true
    });
    this.close();
    this.autoCompleteComp = "";
  },
  updated() {
    if (!this.autoCompleteComp) {
      this.close();
    }
    if (this.autoCompleteComp) {
      if (this.autoCompleteComp.length < this.acMinCharacters) {
        this.close();
      } else if (
        this.autoCompleteComp.length > this.acMinCharacters &&
        this.fireCounter > 1
      ) {
      }
    }
  },
  destroyed() {
    this.destroyListeners();
  },
  methods: {
    debouncer(item) {
      if (item) {
        if (item.length < this.acMinCharacters) {
          this.results = [];
          this.close();
        }
      }
      // Uses lodash debounce method from a variable in the mounted hook to stop the user firing more queries than required
      if (item && item.length >= this.acMinCharacters) {
        this.$debouncedMethod(item);
      }
    },
    autoComplete(search) {
      // stops query being fired on load of component
      if (this.searched != search) {
        if (this.fireCounter > 0 || this.search == "") {
          this.autoCompleteApi(search).then(items => {
            this.results = items;
            this.open();
            this.fireCounter++;
            if (items.length < 1) {
              this.close();
            }
          });
        }
      }
    },
    autoCompleteApi(search) {
      this.query = {};
      this.query.query = search;

      if (this.model == "organization-projects") {
        return new OrganizationApi().projectsList(
          this.$store.state.current_user.organization_id,
          { search: search }
        );
      } else if (this.model == "organization-companies") {
        return new OrganizationApi().companiesList(
          this.$store.state.current_user.organization_id,
          { search: search }
        );
      } else {
        return new Api().searchAutoComplete(this.query, this.query.search);
      }
    },
    close() {
      this.classes = defaultClass + " hidden";
    },
    focus() {
      this.focus = !this.focus;
    },
    open() {
      this.classes = defaultClass;
    },
    handleEvent(event) {
      // If it's a string we simply set this.search equal and continue.
      if (event != undefined) {
        this.search = event;
      }
    },
    filterResultsBySearch() {
      if (!this.item[this.name]) {
        this.results = this.items;
        return;
      }
      this.results = this.items.filter(company => {
        return company.name
          .toString()
          .toLowerCase()
          .includes(this.item[this.name].toString().toLowerCase());
      });
    },
    emitResult(result) {
      // Go into Vuex when we at some point switch to that
      this.$emit("change", result);
      this.populateFields(result);
      this.close();
    },
    populateFields(result) {
      let resulty = result;

      if (this.model == "organization-projects") {
        this.projectFields.name = resulty.name;
        this.$emit("populate-fields", this.projectFields);
      } else if (this.model == "organization-companies") {
        this.companyFields.name = resulty.name;
        this.$emit("populate-fields", this.companyFields);
      } else {
        this.companyFields.city = resulty.city;
        this.companyFields.country = resulty.country;
        this.companyFields.company_website = resulty.website;
        this.companyFields.phone_company = resulty.phone_company;
        this.companyFields.company = resulty.name;
        this.companyFields.zip = resulty.zip;
        this.companyFields.street = resulty.street;
        this.companyFields.street_number = resulty.street_number;
        this.$emit("populate-fields", this.companyFields);
      }
    },
    setResult(result) {
      this.search = result.name;
      this.$emit("change", result);
      this.close();
    },
    onArrowDown(evt) {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.search = this.results[this.arrowCounter];
      this.close();
      this.arrowCounter = -1;
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.close();
        this.arrowCounter = -1;
      }
    },
    initResults() {
      // Set results equal to items
      this.results = this.items;
    },
    addListeners() {
      document.addEventListener("click", this.handleClickOutside);
    },
    destroyListeners() {
      document.removeEventListener("click", this.handleClickOutside);
    }
  },
  computed: {
    autoCompleteComp: {
      set: function(val) {
        if (!this.initCompanyName) {
          this.search = val;            
          this.close();
        } else if (val.length < this.acMinCharacters) this.results = [];
      },
      get: function() {
        return this.init;
      }
    }
  },
  watch: {
    initCompanyName: function() {
      return this.init;
    },
    autoCompleteComp: function() {
      if (this.autoCompleteComp < this.acMinCharacters) {
        this.close();
      }
    }
  }
};
</script>

<style>
li {
  user-select: none;
}
.hidden {
  display: none;
}
.autocomplete {
  position: relative;
}
.autofill {
  margin-bottom: 0px !important;
}
.autocomplete-results {
  position: absolute;
  padding: 4px 0px;
  margin: 0;
  margin-top: -11px;
  border: 0px solid #eee;
  max-height: 160px;
  border-radius: 3px;
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: scroll !important;
  width: 100%;
  z-index: 9;
  background: #fff;
  min-height: 38px;
  border-radius: 4px;
  box-shadow: rgba(34, 48, 73, 0.2) 0px 20px 66px 0px;
}
.field {
  margin-bottom: 0px;
  background: transparent !important;
}
.field input {
  background: transparent !important;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  min-height: 38px;
  padding: 9px 15px;
  background-color: #fff;
  cursor: pointer;
  font-size: 14px;
}

.visually-hidden {
  margin: -1px;
  padding: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip: rect(0, 0, 0, 0);
  position: absolute;
}

.autocomplete-result:hover {
  background-color: #f5f6f7;
  color: black;
}


div#country {
  background: transparent !important;
}
</style>



// WEBPACK FOOTER //
// AutoComplete.vue?17de1693